import { render, staticRenderFns } from "./historyComment.vue?vue&type=template&id=596d1714&scoped=true"
import script from "./historyComment.vue?vue&type=script&lang=js"
export * from "./historyComment.vue?vue&type=script&lang=js"
import style0 from "./historyComment.vue?vue&type=style&index=0&id=596d1714&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596d1714",
  null
  
)

export default component.exports